<div class="registration-form">

    <div class="headerback">
        <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
        <mat-icon>arrow_back</mat-icon>
      </button> -->

        <button mat-mini-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="backhome()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <form class="loginform">
        <!-- <img class="icon icon-user" src="assets/images/recycle.png"> -->
        <div class="header">
            <p class="title">{{publicservice.Texts.Texts['main-page4']}}</p>
        </div>

        <div [class]="key">

            <div class="fieldedit">
                <p style="padding-left: 10px;color: #7ec66a; font-family: iransansbold ">
                    {{publicservice.Texts.Texts['signin7']}}</p>
                <p style="font-size: large;">{{phoneNum}}</p>
            </div>
            <div dir="rtl">
                <mat-form-field class="form-group" appearance="legacy">
                    <mat-label class="label">{{publicservice.Texts.Texts["signin2"]}}
                    </mat-label>
                    <input matInput type="text" class="item" id="name" type="text" value="{{name}}"
                        [(ngModel)]="publicservice.name" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>

            <!-- <mat-form-field class="form-group"  >
            <mat-label class="label">{{publicservice.Texts.Texts["profile1"]}}
            </mat-label>
            <input matInput type="text" class="item" id="phone" type="text" value="09123456789">
        </mat-form-field> -->

            <div dir="ltr">
                <mat-form-field class="form-group-email" appearance="legacy">
                    <mat-label class="label">{{publicservice.Texts.Texts["signin3"]}}
                    </mat-label>
                    <input matInput type="text" class="item" id="email" type="text" value="{{email}}"
                        [(ngModel)]="publicservice.email" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <p [class]="key3" style="font-family: iransans;color: #ff5656;float: right;text-align: right;margin-top: -10px;">این ایمیل قبلا با
                    شماره موبایل دیگری به ثبت رسیده است. لطفا ایمیل دیگری وارد کنید</p>
            </div>


            <div class="form-group-btn">
                <button mat-button type="button" class="btn btn-block create-account" (click)="profileedit()">
                    {{publicservice.Texts.Texts['six-digit2']}}</button>
            </div>
        </div>


        <div [class]="key2" style="width: 500px;">

            <mat-spinner id="loading" *ngIf="loading"></mat-spinner>

            <div class="field">
                <p style="padding-left: 10px;color: #7ec66a; font-family: iransansbold ">
                    {{publicservice.Texts.Texts['signin7']}}</p>
                <p style="font-size: large;">{{phoneNum}}</p>
            </div>


            <div class="field">
                <p style="padding-left: 10px;color: #7ec66a; font-family: iransansbold ">
                    {{publicservice.Texts.Texts['signin6']}}</p>
                <p style="font-size: large;">{{name}}</p>
            </div>

            <div class="field fieldemail" style="word-wrap: break-word;">
                <p style="padding-left: 10px;color: #7ec66a; font-family: iransansbold; " class="emailtitr">
                    {{publicservice.Texts.Texts['signin8']}}</p>
                <p style="font-size: large;word-wrap: break-word;" class="email">{{email}}</p>
            </div>


            <div class="form-group-btn">
                <button mat-button type="button" class="btn btn-block create-account" (click)="profileset()">
                    {{publicservice.Texts.Texts['profile2']}}</button>
            </div>
        </div>

    </form>

    <div class="back-btn">
        <button mat-button type="button" class="back" (click)="exit()">
            {{publicservice.Texts.Texts['profile3']}}</button>
    </div>
</div>